export const SIZE = {
  MOBILE_S: '320px',
  MOBILE_M: '375px',
  MOBILE_L: '425px',
  TABLET: '768px',
  LAPTOP: '1024px',
  DESKTOP_S: '1200px',
  DESKTOP_M: '1440px',
  DESKTOP_L: '2560px'
}

export const SCREEN_SIZE = {
  MOBILE_S: `(max-width: ${SIZE.MOBILE_S})`,
  MOBILE_M: `(max-width: ${SIZE.MOBILE_M})`,
  MOBILE_L: `(max-width: ${SIZE.MOBILE_L})`,
  TABLET: `(max-width: ${SIZE.TABLET})`,
  LAPTOP: `(max-width: ${SIZE.LAPTOP})`,
  DESKTOP_S: `(max-width: ${SIZE.DESKTOP_S})`,
  DESKTOP_M: `(max-width: ${SIZE.DESKTOP_M})`,
  DESKTOP_L: `(max-width: ${SIZE.DESKTOP_L})`
}
